import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/store';
import handleRegisterAsyncData, {
  handleRegisterCountAsyncData,
} from 'global-components/register/OhsModuleRegisterUtils';
import { WmmSysFieldListsRecordState } from 'wmm/models/OhsWmmSysFieldModels';

import { fetchSysFieldListsAsync, fetchSysFieldListsCountAsync } from './OhsWmmSysFieldActions';

const defaultSysFieldLists = {
  items: [],
  pagination: {
    page: 0,
    totalPages: 0,
    next: '',
  },
};
const initialState: WmmSysFieldListsRecordState = {
  isLoading: false,
  sysFieldLists: defaultSysFieldLists,
  currentPage: 1,
};

export const sysFieldSlice = createSlice({
  name: 'sysField',
  initialState,
  reducers: {
    setCurrentRegisterPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSysFieldListsAsync.pending, (state) => {
        state.isLoading = true;
        state.sysFieldLists = defaultSysFieldLists;
      })
      .addCase(fetchSysFieldListsAsync.fulfilled, (state, action) => {
        if (action.payload) {
          const sysFieldList = handleRegisterAsyncData(action.payload, 'sysFieldListtotalPages');
          state.isLoading = false;
          state.sysFieldLists = sysFieldList;
          state.currentPage = sysFieldList.pagination.page ?? 1;
        }
      })
      .addCase(fetchSysFieldListsAsync.rejected, (state) => {
        state.sysFieldLists = defaultSysFieldLists;
      })
      .addCase(fetchSysFieldListsCountAsync.fulfilled, (state, action) => {
        const sysFieldListCountResult: any = action.payload;
        if (state.sysFieldLists && sysFieldListCountResult) {
          const countSysFieldLists = handleRegisterCountAsyncData(
            sysFieldListCountResult,
            state.sysFieldLists,
            'sysFieldListtotalPages'
          );
          state.sysFieldLists = countSysFieldLists;
        }
      });
  },
});

// Memoized Selectors
const sysFieldState = (state: RootState) => state.sysField;
export const getOhsSysFieldLists = createSelector([sysFieldState], (sysField) => sysField);

export const { setCurrentRegisterPage } = sysFieldSlice.actions;
export const sysFieldModuleReducer = sysFieldSlice.reducer;
